import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import { Chip } from '@mui/material';
import { useWizardState } from '../../context/wizard-state.context';
import { getOrgGroups } from '../../utils/org-groups';

const monoText = {
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
  fontSize: 14,
};

// Compact contract-context anchor rendered at the bottom of the
// WizardHeaderCard. Pulled from `state.input` once parsed; renders nothing
// until intake has produced a validated input.
export const WizardContextStrip = (): JSX.Element | null => {
  const { state } = useWizardState();
  const input = state.input;
  if (input == null) return null;

  const groups = getOrgGroups(input);
  const tinCount = groups.length;
  const locationCount = input.locations.length;
  const start = input.contract_details.effective_date;
  const end = input.contract_details.term_end;
  const fsType = input.fee_schedule.type ?? 'Case Rate';

  return (
    <HHStack
      direction="row"
      alignItems="center"
      sx={{
        flexWrap: 'wrap',
        gap: 1.25,
        pt: 2,
        borderTop: theme => `1px solid ${theme.palette.divider}`,
      }}
    >
      <HHTypography hhVariant="subtitle2" sx={{ flexShrink: 0 }}>
        {input.client_name}
      </HHTypography>
      <Chip size="small" variant="outlined" label={fsType} />
      <HHTypography
        hhVariant="caption"
        sx={{ ...monoText, color: 'text.secondary' }}
      >
        {start} → {end}
      </HHTypography>
      <span style={{ flex: 1 }} />
      <HHTypography
        hhVariant="caption"
        sx={{ color: 'text.secondary', fontSize: 14 }}
      >
        {tinCount === 1 ? '1 TIN' : `${tinCount} TINs`} ·{' '}
        {locationCount === 1 ? '1 location' : `${locationCount} locations`}
      </HHTypography>
    </HHStack>
  );
};
